import { useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";
import "./affiliate-auth.css";

const genCode = (p) =>
  p + "_" + Math.random().toString(36).slice(2, 10);

export default function AffiliateSignup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");

    let user;

    const sign = await supabase.auth.signUp({ email, password });
    if (sign.data?.user) user = sign.data.user;

    if (sign.error) {
      const login = await supabase.auth.signInWithPassword({
        email,
        password
      });
      if (login.error) {
        setMsg("Wrong password");
        setLoading(false);
        return;
      }
      user = login.data.user;
    }

    const { data: exists } = await supabase
      .from("affiliates")
      .select("id")
      .eq("id", user.id)
      .single();

    if (!exists) {
      await supabase
        .from("affiliates")
        .insert({
          id: user.id,
          email: user.email,
          balance: 0,
          total_earned: 0,
          total_users: 0,
          revenue_code: genCode("rev"),
          turnover_code: genCode("turn"),
          created_at: new Date().toISOString()
        })
        .select()
        .single();
    }

    navigate("/affiliate/dashboard");
    setLoading(false);
  };

  return (
    <div className="aff-auth-wrapper">
      <form className="aff-auth-box" onSubmit={submit}>
        <h2>Affiliate Signup</h2>
        {msg && <div className="aff-auth-msg">{msg}</div>}
        <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email" />
        <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password" />
        <button disabled={loading}>{loading?"Please wait":"Continue"}</button>
      </form>
    </div>
  );
}
